






























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
const isSupportObjectFit = () => document.documentElement.style.objectFit !== undefined;
const ObjectFit = {
  NONE: 'none',
  CONTAIN: 'contain',
  COVER: 'cover',
  FILL: 'fill',
  SCALE_DOWN: 'scale-down',
};
@Component({
  name: 'lb-img',
  inheritAttrs: false,
})
export default class extends Vue {
  @Prop({ required: true }) private src!: string;
  @Prop() private defaultSrc!: string;
  @Prop() private fit!: string;

  private loading = true;
  private error = false;
  private imageWidth = 0;
  private imageHeight = 0;
  // private defaultImg = require('../../assets/default.svg');

  get imageStyle() {
    if (this.fit) {
      return isSupportObjectFit()
              ? { 'object-fit': this.fit }
              : this.getImageStyle(this.fit);
    }
    return {};
  }

  public created() {
    if (this.src || this.defaultSrc) {
      this.loadImage();
    } else {
      this.loading = false;
    }
  }

  @Watch('src')
  private onSrcChange() {
    if (this.src || this.defaultSrc) {
      this.loadImage();
    } else {
      this.loading = false;
    }
  }

  private loadImage() {
    this.loading = true;
    this.error = false;
    const img = new Image();
    img.onload = (e) => this.handleLoad(e, img);
    img.onerror = this.handleError.bind(this);
    // bind html attrs
    Object.keys(this.$attrs)
            .forEach((key) => {
              const value = this.$attrs[key];
              img.setAttribute(key, value);
            });
    img.src = this.src || this.defaultSrc;
  }

  private handleLoad(e: any, img: any) {
    this.imageWidth = img.width;
    this.imageHeight = img.height;
    this.loading = false;
  }

  private handleError(e: any) {
    this.loading = false;
    this.error = true;
    this.$emit('error', e);
  }

  private getImageStyle(fit: string) {
    const { imageWidth, imageHeight } = this;
    const {
      clientWidth: containerWidth,
      clientHeight: containerHeight,
    } = this.$el;

    if (!imageWidth || !imageHeight || !containerWidth || !containerHeight) { return {}; }

    const vertical = imageWidth / imageHeight < 1;

    if (fit === ObjectFit.SCALE_DOWN) {
      const isSmaller = imageWidth < containerWidth && imageHeight < containerHeight;
      fit = isSmaller ? ObjectFit.NONE : ObjectFit.CONTAIN;
    }

    switch (fit) {
      case ObjectFit.NONE:
        return { width: 'auto', height: 'auto' };
      case ObjectFit.CONTAIN:
        return vertical ? { width: 'auto' } : { height: 'auto' };
      case ObjectFit.COVER:
        return vertical ? { height: 'auto' } : { width: 'auto' };
      default:
        return {};
    }
  }
}
